import {TheCage} from "../../TheCage";
import {TheCageGameAssets} from "../../TheCageGameAssets";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";

/**
 * Created by jonas on 2022-12-06.
 */

export class ParticleBurst extends PIXI.Container {
    constructor() {
       super();
    }

    public playAnimation(level:number, pos:PIXI.Point = new PIXI.Point(360, 360)){
        const scale = 0.5 + (0.3 * level);
        const explodeGfx = new TimelineSprite(TheCage.assetLoader.getTextures(TheCageGameAssets.MULTIPLIER_UPDATE),30);
        explodeGfx.anchor.set(0.5,0.5);
        explodeGfx.scale.set(scale,scale);
        explodeGfx.blendMode = PIXI.BLEND_MODES.ADD;
        explodeGfx.rotation = Math.random() * Math.PI;
        explodeGfx.position.set(pos.x, pos.y);

        const tl = explodeGfx.getAnimationAutoShowHide(true,true);
        tl.add(()=>{
            this.addChild(explodeGfx);
        },0);
        tl.add(()=>{
            this.removeChild(explodeGfx);
        });
    }

}